import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

import { MEDIA_QUERIES } from "@constants";


export const DEIPagePrinciplesSectionSECTION = styled.section`
  position: relative;
  margin-bottom: 80px;
  
  ${MEDIA_QUERIES.M} {
    padding-bottom: 240px;
  }
`;

export const DEIPagePrinciplesSectionGridDIV = styled.div.attrs({ className: "grid" })`
  h2 {
    margin-bottom: 80px;
  }
`;

export const DEIPagePrinciplesSectionCardsDIV = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing--M) var(--spacing--M);
  margin-bottom: var(--spacing--L);

  > div {
    flex: 0 0 100%;

    h4 {
      margin: 0 0 20px;
    }

    p {
      color: var(--color--text-default);
    }

    .gatsby-image-wrapper {
      margin-left: -10px;
      margin-bottom: 20px;
      width: 80px;
    }

    ${MEDIA_QUERIES.M} {
      flex: 0 0 calc(50% - (var(--spacing--M) * 1 / 2));
    }
  }
`;

export const DEIPagePrinciplesSectionStripeWrapperDIV = styled.div`
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 601px;
  overflow: hidden;

  .gatsby-image-wrapper {
    width: 1920px;
  }

  ${MEDIA_QUERIES.M} {
    display: block;
  }
`;

export const DEIPagePrinciplesSectionStripeIMG = styled(GatsbyImage)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;
